.breadcrumbs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  margin-top: 24px;
  padding-right: 16px;
  white-space: nowrap;
}

.breadcrumbText {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 15px;
}

.breadcrumbs--desktop-only {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .breadcrumbs--desktop-only {
    display: flex;
  }

  .breadcrumbText {
    font-size: 16px;
  }
}
